import { useEffect, useRef, useState, useCallback } from 'react';
import { api } from '@/lib/api';

/**
 * Polls a backend path every `intervalMs` ms and returns the latest data.
 * Calls `onChange(data)` whenever `last_updated` changes since the last tick.
 */
export function usePolling(path, { intervalMs = 5000, enabled = true, onChange } = {}) {
    const [data, setData] = useState(null);
    const lastRef = useRef(null);
    const cbRef = useRef(onChange);
    cbRef.current = onChange;

    const tick = useCallback(async () => {
        try {
            const { data: d } = await api.get(path);
            setData(d);
            const lu = d?.last_updated || null;
            if (lu && lu !== lastRef.current) {
                if (lastRef.current !== null) {
                    cbRef.current?.(d);
                }
                lastRef.current = lu;
            }
        } catch (_) { /* ignore */ }
    }, [path]);

    useEffect(() => {
        if (!enabled || !path) return undefined;
        tick();
        const id = setInterval(tick, intervalMs);
        return () => clearInterval(id);
    }, [path, intervalMs, enabled, tick]);

    return data;
}
